import {useEffect} from "react";
import {Outlet} from "react-router-dom";
import {Box} from "@chakra-ui/react";
import {toaster} from "../Components/ui/toaster";
import {Header, Footer, ProductModal} from "../Components";

const RootLayout = () => {
  useEffect(() => {
    toaster.create({
      description:
        "All calculation results are estimate and may differ from real-life usage scenario.",
      type: "warning",
      closable: true,
      duration: 9000,
    });
  }, []);

  return (
    <div>
      <Header />
      <Box maxH={"calc(100vh - 130px)"} overflow={"auto"} margin={"0 0 2rem 0"}>
        <Outlet />
        <ProductModal />
      </Box>
      <Footer />
    </div>
  );
};

export default RootLayout;
